import { string } from 'yup';

export const VALIDATION_MESSAGES = {
	required: 'This field is required.',
	past_schedule: 'Cannot schedule ride in the past',
	incorrect_exp_date: 'Incorrect expiry date.',

	file_required: 'Uploaded file required.',
	at_least_one: 'At least one (1) option must be selected.',
	requiredShort: 'Required',
	email: 'Invalid email format for username',
	password_minimum_length: 'The password must be at least eight (8) characters',
	password_lower_case: 'The password must contain at least one (1) lowercase alphabetical character',
	password_upper_case: 'The password must contain at least one (1) uppercase alphabetical character',
	password_numeric: 'The password must contain at least one (1) numeric character',
	password_special_character: 'The password must contain at least one (1) special character',
	add_location: 'Please add a location.',
};

export const PASSWORD_REQUIREMENTS = {
	minimumPasswordLength: 8,
	lowerCaseRegex: /^(?=.*[a-z])/,
	upperCaseRegex: /^(?=.*[A-Z])/,
	numericRegex: /^(?=.*[0-9])/,
	specialCharacterRegex: /^(?=.*[.!@#$%^&*])/,
};

export const passwordValidation = string()
	.min(
		PASSWORD_REQUIREMENTS.minimumPasswordLength,
		`Must be at least ${PASSWORD_REQUIREMENTS.minimumPasswordLength} characters`,
	)
	.matches(
		PASSWORD_REQUIREMENTS.lowerCaseRegex,
		'Must contain at least 1 lowercase alphabetical character',
	)
	.matches(
		PASSWORD_REQUIREMENTS.upperCaseRegex,
		'Must contain at least 1 uppercase alphabetical character',
	)
	.matches(
		PASSWORD_REQUIREMENTS.numericRegex,
		'Must contain at least 1 numeric character',
	);
